export default "__VITE_PUBLIC_ASSET__d0226aa0__"